<div
  #scrollContainer
  class="ai-chat-messages"
  role="log"
  aria-live="polite"
  aria-label="Chat messages"
  aria-atomic="false">
  @if (messages().length === 0) {
    <div class="ai-chat-empty">
      <div class="title-animation ai-chat-empty__hello">
        <span>Hi</span>
        <span>
          {{ (currentUser()?.visibleName || currentUser()?.name || '') + ',' }}
        </span>
      </div>
      <div class="title-animation ai-chat-empty__prompt">How can I help?</div>
      @for (initialMessage of initialMessages(); track $index) {
        <button
          test-id="ai-chat-message-list-initial-message-click-emit"
          type="button"
          class="initial-message"
          [style.animation-delay]="($index + 1) * 100 + 'ms'"
          (click)="initialMessageClick.emit(initialMessage)">
          <i class="pi pi-bolt action-icon"></i>
          <span>{{ initialMessage }}</span>
        </button>
      }
    </div>
  } @else {
    @for (msg of messages(); track msg.id ?? $index; let isLast = $last) {
      <div
        class="message-row"
        [class.message-row--user]="msg.author === 'user'"
        [class.message-row--bot]="msg.author === 'bot'">
        @if (
          msg.id === 'loading-message' ||
          (msg.id === 'streaming-message' && !msg.parts?.length && !msg.text)
        ) {
          <span
            class="bot-avatar"
            aria-hidden="true">
            <i class="pi pi-sparkles"></i>
          </span>
          <div class="message-content">
            <div class="message-bubble message-bubble--bot">
              <div
                class="thinking-status"
                data-test-id="thinking-status">
                <i class="pi pi-lightbulb tw:text-sm"></i>
                <span>{{ thinkingLabel() }}...</span>
              </div>
            </div>
          </div>
        } @else if (msg.author === 'user') {
          <div class="message-content">
            <div class="message-bubble">{{ msg.text }}</div>
            <div
              class="message-actions"
              [class.is-last]="isLast">
              <button
                test-id="ai-chat-message-list-copy"
                type="button"
                class="message-action-btn"
                pTooltip="Copy"
                tooltipPosition="bottom"
                (click)="copyClick.emit(msg.text)"
                aria-label="Copy message">
                <i class="pi pi-copy"></i>
              </button>
            </div>
          </div>
        } @else {
          <span
            class="bot-avatar"
            aria-hidden="true">
            <i class="pi pi-sparkles"></i>
          </span>
          <div class="message-content">
            <div class="message-bubble message-bubble--bot">
              @if (msg.parts?.length) {
                <cor-ai-chat-message-parts
                  [parts]="msg.parts!"
                  (rendered)="handleMarkdownReady()" />
              } @else {
                <markdown
                  [data]="msg.text"
                  clipboard
                  (ready)="handleMarkdownReady()" />
              }
            </div>
            <div
              class="message-actions"
              [class.is-last]="isLast">
              <button
                test-id="ai-chat-message-list-copy-2"
                type="button"
                class="message-action-btn"
                pTooltip="Copy"
                tooltipPosition="bottom"
                (click)="copyClick.emit(msg.text)"
                data-test-id="copy-ai-response-button"
                aria-label="Copy response">
                <i class="pi pi-copy"></i>
              </button>
              @if (msg.id === 'error-message') {
                <button
                  test-id="ai-chat-message-list-retry"
                  type="button"
                  class="message-action-btn"
                  pTooltip="Retry"
                  tooltipPosition="bottom"
                  (click)="retryClick.emit()"
                  aria-label="Retry last message">
                  <i class="pi pi-undo"></i>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  }
</div>
